var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mouth",class:{
    'mouth-open': _vm.mouthState === 'open',
    'mouth-open-teeth': _vm.mouthState === 'open-teeth',
    'mouth-teeth': _vm.mouthState === 'teeth',
    'mouth-o': _vm.mouthState === 'o'  
  }},[_c('div',{staticClass:"mouth__closed"}),_c('div',{staticClass:"mouth__open"}),_c('div',{staticClass:"mouth__open-teeth"}),_c('div',{staticClass:"mouth__teeth"}),_c('div',{staticClass:"mouth__o"})])}
var staticRenderFns = []

export { render, staticRenderFns }